import { useCallback, useEffect, useState } from "react";
import { apiCollections } from "../services";
import { usePaginatedFetch } from "./usePaginatedFetch";
import { ICollection } from "@/common/services/types";

interface IUseUserCollectionsDataProps {
  userName?: string;
}

export const useUserCollectionsData = (
  { userName }: IUseUserCollectionsDataProps
) => {
  const [collections, setCollections] = useState<ICollection[]>([]);

  const fetchFunc = useCallback(
    async (page: number = 1) => {
      const res = await apiCollections.getUserCollections({
        userId: userName,
        page: page,
        count: 50,
      });

      return {
        items: res.collections,
        page,
        pages: res.pages,
        total: res.totalCount,
      };
    },
    [userName]
  );

  const pager = usePaginatedFetch(fetchFunc, !!userName);

  useEffect(() => {
    setCollections(pager.items);
  }, [pager.items]);

  const addCollection = useCallback((collection: ICollection) => {
    setCollections(prev => [collection, ...prev]);
  }, []);

  return {
    collections,
    totalCollections: pager.totalCount,
    loading: pager.isLoading,
    error: pager.error,
    loadMore: pager.loadMore,
    addCollection,
    hasMore: pager.hasMore,
  };
};
